import React from 'react';
import logo from './logo.svg';
import './App.css';
import Capture from './components/capture.jsx';

function App() {
  return (
    <div className="App" >
      <Capture />
    </div>
  );
}

export default App;
